import styled from '@emotion/styled';
import { withConfig } from 'src/utils/withConfig';
import { setMainLogoWrapper } from 'src/components/Header/Logotype.style';
import { PricedUpCompliancePopupLogo } from 'src/assets/logos/compliancePopup/PricedUpCompliancePopupLogo';
import { PricedUpLogo } from 'src/assets/logos/PricedUpLogo';
import { PricedUpBrandIcon } from 'src/assets/brandIcons/PricedUpBrandIcon';
import { compliancePopupLogoCss } from 'src/domains/common/universes/compliancePopupLogoCss';

export const PricedUpMainLogoWrapper = withConfig(theme => styled('div', { label: 'PricedUpMainLogoWrapper' })`
    ${setMainLogoWrapper(theme)};
`);

export const PricedUpMainLogo = styled(PricedUpLogo, { label: 'PricedUpMainLogo' })`
    width: 95px;
    height: 24px;
    margin: 0 auto;
`;

export const PricedUpBrandIconWrapper = styled(PricedUpBrandIcon, { label: 'PricedUpBrandIconWrapper' })`
    cursor: pointer;
    flex: 0 0 32px;
    margin: 0 auto;
    width: 32px;
`;

export const CompliancePopupLogo = styled(PricedUpCompliancePopupLogo, { label: 'CompliancePopupLogo' })`
    ${compliancePopupLogoCss}
`;
